import { TransferBetweenAccounts } from '@/components/pages/Transfer/BetweenAccounts'
import { api } from '@/hooks/api'
import { useAuth } from '@/hooks/useAuth'
import { useIdleSessionTimeout } from '@/hooks/useIdleSessionTimeout'
import { normalizeCnpj } from '@/utils/normalize'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { BiTransferAlt } from 'react-icons/bi'
import { ModalUpdatePassword } from '../ModalUpdatePassword'
import { NotificationsCenter } from '../Notifications'

import { Clock } from './clock'
import { Container } from './styles'
import { UserMenu } from './userMenu'
import { HasPermission } from '../HasPermission'

const productionHosts = ['app2mig.bfcdigital.com.br', 'admin.ocix.com.br']

export const Header: React.FC = () => {
  const router = useRouter()
  const { user, signOut } = useAuth()

  const [transfer, setTransfer] = useState(false)

  const [updatePassword, setUpdatePassword] = useState(false)

  const [subscriberParametersData, setSubscriberParametersData] =
    useState<Subscriber | null>(null)

  // A sessão continua expirando por inatividade — a contagem só deixou de ter representação
  // visual quando o contador mm:ss saiu do cabeçalho.
  useIdleSessionTimeout(
    subscriberParametersData?.idle_session_timeout_minutes,
    Boolean(subscriberParametersData?.use_idle_session_timeout)
  )

  const [homologEnviroment, setHomologEnviroment] = useState(false)

  useEffect(() => {
    setHomologEnviroment(!productionHosts.includes(window.location.hostname))
  }, [])

  useEffect(() => {
    if (!user?.subscriber) return
    loadSubscriber()
  }, [user])

  async function loadSubscriber() {
    try {
      const { data } = await api.get(`subscribers/${user.subscriber.id}`)
      setSubscriberParametersData(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function handleLogout() {
    signOut()
  }

  return (
    <Container
      className="container-fluid no-print"
      style={{ borderBottom: homologEnviroment ? '4px solid orange' : '' }}
    >
      {transfer && (
        <TransferBetweenAccounts onHide={() => setTransfer(false)} />
      )}
      {updatePassword && (
        <ModalUpdatePassword
          onHide={() => {
            setUpdatePassword(false)
          }}
        />
      )}
      <div className="d-flex justify-content-between align-items-center flex-wrap cont">
        <div className="d-flex align-items-center">
          <button onClick={() => router.push('/')} className="text-white">
            <img
              className="logo"
              src="/logo-ocix-completa-3-branca.svg"
              alt="OCIX"
            />
          </button>

          <div className="d-flex flex-column align-items-start ml-3">
            <strong
              className="text-white radius-4 mb-0 pt-1 pb-1 pl-2 pr-2 company_logged"
              style={{
                fontSize: '0.7rem',
                background: 'rgba(255,255,255,.2)'
              }}
            >
              {user?.subscriber?.name} - {normalizeCnpj(user?.subscriber?.cnpj)}
            </strong>

            <div>
              {homologEnviroment ? (
                <Badge variant="warning" className="mt-1">
                  Ambiente de Homologação
                </Badge>
              ) : null}
            </div>
          </div>
        </div>

        <div className="widgets">
          <Clock />
          <HasPermission permission="Ver Contas Corrente (Root)">
            <button
              type="button"
              className="btn btn-primary bg-none p-0"
              onClick={() => setTransfer(true)}
            >
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="tip-transfer">
                    Transferência entre contas
                  </Tooltip>
                }
              >
                <BiTransferAlt className="m-0" />
              </OverlayTrigger>
            </button>
          </HasPermission>

          <NotificationsCenter />

          <UserMenu
            onOpenCommitteeTemplates={() => router.push('/committee-templates')}
            onUpdatePassword={() => setUpdatePassword(true)}
            onLogout={handleLogout}
          />
        </div>
      </div>
    </Container>
  )
}
